export const appRoutes = {
  bankAccounts: '/bank-accounts',
  legacyDeposit: '/deposit',
  legacyTransactionHistory: '/transaction-history',
  transactions: {
    root: '/transactions',
    deposit: '/transactions/deposit',
    history: '/transactions/history',
    withdrawal: '/transactions/withdrawal',
  },
} as const;

export const buildDepositRoute = (...segments: Array<string | number | undefined>) =>
  [appRoutes.transactions.deposit, ...segments.filter(segment => segment !== undefined && segment !== '')].join('/');
